import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import video1 from "../../assets/videos/cocvideo12.mp4";
import video2 from "../../assets/videos/videoplayback.webm";
import video3 from "../../assets/videos/videoplayback (2).mp4";
import video4 from "../../assets/videos/cocvideo14.mp4";
import video5 from "../../assets/videos/growingPeppers.mp4";

const videoData = [
  { id: 1, src: video1, title: "Sprinkle the granules", button: "View Product", path: "/products" },
  { id: 2, src: video2, title: "Enhances growth", button: "View Product", path: "/products" },
  { id: 3, src: video3, title: "Organic Pesticide - Neem oil", button: "View Product", path: "/products" },
  { id: 4, src: video4, title: "Planting new life in the garden", button: "View Product", path: "/products" },
  { id: 5, src: video5, title: "Potting Mixture", button: "View Product", path: "/products" },
];

const AutoPlayVideos = () => {
  const videoRefs = useRef([]);

  useEffect(() => {
    const playVideos = () => {
      videoRefs.current.forEach((video) => {
        if (video) {
          video.play().catch((err) => console.warn("Autoplay prevented:", err));
        }
      });
    };

    // Play videos when the tab is visible
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        playVideos();
      }
    };

    // Initial attempt to play videos
    playVideos();

    // Listen for visibility changes
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return (
    <div className="bg-white py-10">
      <h2 className="text-center text-3xl font-bold text-green-700 mb-6">Watch & Shop</h2>
      <div className="flex overflow-x-auto space-x-6 px-4">
        {videoData.map((video, index) => (
          <div
            key={video.id}
            className="flex-shrink-0 w-64 rounded-lg overflow-hidden shadow-lg bg-gray-100"
          >
            <video
              ref={(el) => (videoRefs.current[index] = el)}
              src={video.src}
              loop
              muted
              playsInline
              className="w-full h-64 object-cover"
            ></video>
            <div className="p-4 text-center">
              <p className="text-gray-700 font-medium mb-4">{video.title}</p>
              <Link to={video.path}>
                <button className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition duration-300">
                  {video.button}
                </button>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AutoPlayVideos;
